// membersTab/container.js
import React, { useState, useEffect } from 'react';
import MembersTabView from './view';
import MemberDetail from '../memberDetail';
import { postMembershipApproval } from 'api';

const MembersTab = ({
  community,
  members,
  isAdmin,
  onMemberClick,
  onInviteMember,
  onMembershipUpdate
}) => {

  const [memberDetailOpen, setMemberDetailOpen] = useState(false);
  const [selectedMemberForDetail, setSelectedMemberForDetail] = useState(null);

  // ✅ Update selectedMemberForDetail when members array changes
  useEffect(() => {
    if (selectedMemberForDetail && members) {
      // Find the updated member in the members array
      const updatedMember = members.find(m => m.slug === selectedMemberForDetail.slug);
      if (updatedMember) {
        setSelectedMemberForDetail(updatedMember);
      }
    }
  }, [members, selectedMemberForDetail]);

  // Updated frontend handler functions
  const handleApproveMember = async (membershipSlug, rejectReason) => {
    try {
      const response = await postMembershipApproval(community.slug, membershipSlug, {
        action: 'approve',
        reason: rejectReason || 'No reason provided'
      });


      // Check if response has data property or if response IS the data
      const responseData = response.data || response;

      if (responseData && responseData.success) {
        // Notify parent component to refresh data
        if (onMembershipUpdate) {
          onMembershipUpdate('approved', membershipSlug, responseData);
        }
        return { success: true, ...responseData };
      } else {
        console.error('Failed to approve member: No success in response');
        return { success: false, error: 'Approval failed' };
      }
    } catch (error) {
      console.error('Error approving member:', error);
      return {
        success: false,
        error: error.response || error.message || 'Network error'
      };
    }
  };

  const handleRejectMember = async (membershipSlug, rejectReason) => {
    try {
      const response = await postMembershipApproval(community.slug, membershipSlug, {
        action: 'reject',
        reason: rejectReason || 'No reason provided'
      });


      // Check if response has data property or if response IS the data
      const responseData = response.data || response;

      if (responseData && responseData.success) {
        // Notify parent component to refresh data
        if (onMembershipUpdate) {
          onMembershipUpdate('rejected', membershipSlug, responseData);
        }
        return { success: true, ...responseData };
      } else {
        console.error('Failed to reject member: No success in response');
        return { success: false, error: 'Rejection failed' };
      }
    } catch (error) {
      console.error('Error rejecting member:', error);
      return {
        success: false,
        error: error.response || error.message || 'Network error'
      };
    }
  };

  const handleMemberClick = (member, action) => {
    if (action === 'profile' || action === 'detail') {
      setSelectedMemberForDetail(member);
      setMemberDetailOpen(true);
    }
  };

  return (
    <>
      <MembersTabView
        members={members}
        isAdmin={isAdmin}
        onMemberClick={handleMemberClick}
        onInviteMember={onInviteMember}
        onApproveMember={handleApproveMember}
        onRejectMember={handleRejectMember}
      />
      
      <MemberDetail
        member={selectedMemberForDetail}
        open={memberDetailOpen}
        onClose={() => setMemberDetailOpen(false)}
        isAdmin={isAdmin}
        onMemberUpdate={onMembershipUpdate}
      />
    </>
  );
};

export default MembersTab;